import { useCallback, useEffect, useRef, useState } from 'react';

export const useScrollPageEvent = () => {
  const lastHeight = useRef(0);
  const lastPageChangeTime = useRef(0);
  const getPage = useCallback(() => {
    const queryParams = new URLSearchParams(window.location.hash.split('?')[1]);
    return Number(queryParams.get('page') || 1);
  }, []);

  const isLoaded = useRef(false);
  const [page, _setPage] = useState(getPage());

  const handleScroll = useCallback(() => {
    if (lastHeight.current >= window.scrollY) return;

    const now = Date.now();
    if (now - lastPageChangeTime.current < 30) return;

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollTop + windowHeight + 150 >= documentHeight) {
      lastHeight.current = scrollTop;
      lastPageChangeTime.current = now;
      _setPage((prevPage) => prevPage + 1);
    }
  }, [_setPage]);

  useEffect(() => {
    if (isLoaded.current) return;
    isLoaded.current = true;

    window.addEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const setPge = useCallback(
    (page: number) => {
      lastHeight.current = 0;
      lastPageChangeTime.current = 0;
      _setPage(page);
    },
    [_setPage, lastHeight, lastPageChangeTime]
  );
  return { page, setPage: setPge };
};
